import * as React from "react";
import { connect } from "react-redux";

import { SSTable } from "../common/TableData";

function TeamsMapTab({ teams, teamsMap }) {
  const unmappedteams = Object.keys(teams || {}).filter((v) => teams[v].isNew);

  return (
    <div>
      <p>
        This import will create
        {unmappedteams.length} teams
      </p>

      <SSTable>
        <thead>
          <tr>
            <td>Name</td>
            <td>Binding</td>
          </tr>
        </thead>
        <tbody>
          {Object.keys(teams || {}).map((v) => (
            <tr
              key={v}
              style={{ backgroundColor: teams[v].isNew ? "lightyellow" : "" }}
            >
              <td>{teams[v].name}</td>
              <td style={{ width: "200px" }}>
                <p>{teamsMap[v] ? teamsMap[v].name : "Will create"}</p>
              </td>
            </tr>
          ))}
        </tbody>
      </SSTable>
    </div>
  );
}

function mapStateToProps(state, props) {
  return {
    teamsMap: state.teams,
  };
}

function mapDispatchToProps(dispatch) {
  return {};
}

export default connect(mapStateToProps, mapDispatchToProps)(TeamsMapTab);
